import AccountService from "../services/AccountService.js";
import PlayerIdentity from "../services/PlayerIdentity.js";
import { PICTO_STAR } from "./Pictos.js";

/**
 * Retours sur les modes du Lab : chaque partie terminée est comptée, et
 * l'écran de fin propose de noter le mode (1 à 5 étoiles, commentaire
 * facultatif). Le back-office en tire ce qui est joué et ce qui plaît (onglet
 * « Le Lab »). Rien de bloquant : hors ligne, la carte reste simplement là.
 *
 * Une note par appareil et par mode, modifiable (`geonerd.labRating.<mode>`
 * garde la dernière pour l'afficher).
 */
const ratingKey = (mode) => `geonerd.labRating.${mode}`;

const escapeHtml = (s) => String(s)
	.replace(/&/g, "&amp;")
	.replace(/</g, "&lt;")
	.replace(/>/g, "&gt;")
	.replace(/"/g, "&quot;");

export function recordLabPlay(mode) {
	if (!mode) return;
	AccountService.request("POST", "/lab/play", { mode, device: PlayerIdentity.getOrCreateId() }).catch(() => {});
}

function lang() {
	return window.geoNerdApp.languageManager.currentLang === "en" ? "en" : "fr";
}

/**
 * Carte de notation, insérée avant `before` (la rangée d'actions de l'écran de
 * fin) ou à la fin de `container`.
 */
export function renderLabRating(container, mode, before = null) {
	if (!container || !mode) return;
	container.querySelector(".lab-rating")?.remove();
	const t = (k) => window.geoNerdApp.languageManager.t(k);
	const previous = parseInt(localStorage.getItem(ratingKey(mode)), 10) || 0;
	const stars = [1, 2, 3, 4, 5].map(n => `
		<button type="button" class="lab-star${n <= previous ? " is-on" : ""}" data-rating="${n}" aria-label="${n}/5">${PICTO_STAR}</button>`).join("");
	const html = `
		<div class="lab-rating" role="group" aria-label="${escapeHtml(t("lab.rating.title"))}">
			<p class="lab-rating-title">${escapeHtml(t(previous ? "lab.rating.again" : "lab.rating.title"))}</p>
			<div class="lab-stars">${stars}</div>
			<form class="lab-rating-comment" hidden>
				<textarea maxlength="500" rows="2" placeholder="${escapeHtml(t("lab.rating.placeholder"))}"></textarea>
				<button type="submit" class="btn btn-secondary">${escapeHtml(t("lab.rating.send"))}</button>
			</form>
			<p class="lab-rating-thanks" hidden>${escapeHtml(t("lab.rating.thanks"))}</p>
		</div>`;
	if (before) before.insertAdjacentHTML("beforebegin", html);
	else container.insertAdjacentHTML("beforeend", html);

	const card = container.querySelector(".lab-rating");
	const form = card.querySelector(".lab-rating-comment");
	const thanks = card.querySelector(".lab-rating-thanks");
	let rating = previous;

	const send = (extra = {}) => AccountService.request("POST", "/lab/rating", {
		mode, device: PlayerIdentity.getOrCreateId(), rating, lang: lang(), ...extra,
	}).catch(() => {});

	card.querySelectorAll(".lab-star").forEach(star => star.addEventListener("click", () => {
		rating = Number(star.dataset.rating);
		localStorage.setItem(ratingKey(mode), String(rating));
		card.querySelectorAll(".lab-star").forEach(s => s.classList.toggle("is-on", Number(s.dataset.rating) <= rating));
		send();
		form.hidden = false;
		thanks.hidden = false;
	}));
	form.addEventListener("submit", (e) => {
		e.preventDefault();
		const comment = form.querySelector("textarea").value.trim();
		if (comment) send({ comment });
		form.hidden = true;
		thanks.textContent = t("lab.rating.thanksComment");
	});
}
